import React from "react";
import { Link } from "react-router-dom";
import { Link as Scroll } from "react-scroll";
import { Carousel } from "react-bootstrap";

const BackgroundVideo = () => {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    let showVideo = true;
    if (/windows phone/i.test(userAgent) || /android/i.test(userAgent) || (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream)) {
        showVideo = false;
    }
    const videoSource = "../images/video/home.mp4"
    return (
        <section className="VideoContainer" >
            <video autoPlay="autoplay" loop="loop" muted className="Video d-view no-ios" >
            {
                showVideo ? (
                <source className="d-view no-ios" src={videoSource} type="video/mp4" />
                /*Your browser does not support the video tag.*/
                ) : null
            }
            </video>
            <div className="Content">
                <div className="SubContent" >
                    <h1 className="header_title text-left pt-2 pb-2 mb-0 mx-auto">
                    Get WiFi <br />
                    Anywhere Anytime
                    </h1>
                    <div className="bannerSubtitle">
                    SINCE 2003, MIGHTYWIFI AND PARTNERS HAVE CONNECTED MILLIONS OF CUSTOMERS WORLDWIDE
                    </div>
                    <div className="header_btn">
                    <Link
                      to="/rent"
                      className="btn btn-custom orange mt-4 mr-3"
                    >
                      RENT
                    </Link>
                    <Link
                      to="/buy/device"
                       className="btn btn-custom mt-4"
                    >
                        BUY
                    </Link>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default BackgroundVideo



// WEBPACK FOOTER //
// ./src/layout/CarouselVideo.js